import {applyMiddleware, createStore as _createStore} from 'redux';
import createMiddleware from './middleware/clientMiddleware';
import RaceUpdateMiddleware from '../modules/HorseRacing/middleware/raceUpdateFactory';
import MyStableUnsubscribeMiddleware from '../modules/HorseRacing/middleware/myStableEmailUnsubscribeFactory';
import ApiRequestMiddleware from '../modules/Common/middleware/apiRequestFactory';
import FeedbackMiddleware from '../modules/Common/middleware/feedbackSubmitFactory';
import {routerMiddleware} from 'react-router-redux';
import {composeWithDevTools} from 'redux-devtools-extension/developmentOnly';
import TrackingEventsMiddleware from '../modules/Common/middleware/trackingEvents';
import cookieMiddleware from '../modules/Common/middleware/cookies';
import errorTracking from '../modules/HorseRacing/middleware/errorTracking';
import {insiderLogin} from 'modules/Insider/middleware/insiderLogin';
import windowEventMiddleware from 'modules/Common/middleware/windowEventsFactory';
import ssoMiddlewareFactory from 'modules/Common/middleware/ssoMiddlewareFactory';
import betslipMiddlewareFactory from '../modules/Common/middleware/betslipMiddlewareFactory';
import menuEvents from '../modules/Common/middleware/menuEvents';
import tamGptInitializationMiddleware from 'modules/Common/middleware/tamGptInitialization';
import splashpageMiddleware from 'modules/Common/middleware/splashpageMiddleware';

import OmnitureAnalytics from '../utils/OmnitureAnalytics';
import GoogleAnalytics from '../utils/GoogleAnalytics';
import Config from '../config';
import ApiClient from 'utils/ApiClient'

const trackingEventsMiddleware = new TrackingEventsMiddleware(GoogleAnalytics, OmnitureAnalytics, Config)
const ssoMiddleware = ssoMiddlewareFactory(Config);

export default function createStore(history, client, data) {
  // Sync dispatched route actions to the history
  const reduxRouterMiddleware = routerMiddleware(history);
  const raceUpdateMiddleware = new RaceUpdateMiddleware();
  const myStableEmailUnsubscribeMiddleware = new MyStableUnsubscribeMiddleware();
  const apiRequestMiddleware = new ApiRequestMiddleware();
  const feedbackMiddleware = new FeedbackMiddleware();
  const betslipMiddleware = new betslipMiddlewareFactory(Config);
  const splashMiddleware = splashpageMiddleware(new ApiClient(), Config);

  const middleware = [
    createMiddleware(client),
    reduxRouterMiddleware,
    ...trackingEventsMiddleware,
    ...myStableEmailUnsubscribeMiddleware,
    ...raceUpdateMiddleware,
    errorTracking,
    insiderLogin,
    ...cookieMiddleware(),
    ...windowEventMiddleware(),
    ...apiRequestMiddleware,
    ...feedbackMiddleware,
    ...betslipMiddleware,
    ...menuEvents(),
    ...ssoMiddleware,
    ...splashMiddleware,
    ...tamGptInitializationMiddleware()
  ];

  const composeEnhancers = composeWithDevTools({});

  let finalCreateStore = composeEnhancers(applyMiddleware(...middleware))(_createStore);

  const reducer = require('./reducer').default;
  const store = finalCreateStore(reducer, data);

  return store;
}



// WEBPACK FOOTER //
// ./redux/store.js